var brandInfoAll={
  bannerInfo:{
    bannerNmae:"图漾科技",
    createTime:"2011年",
    area:"中国 上海",
    honor:[
      '上海市高新技术企业',
      '上海市人工智能企业50强',
      '2019年国际工业博览会工业自动化奖'
    ]
  },
  subsidiary:[
    {
      name:"上海",
      langname:"上海（总公司）",
      address:"上海市浦东新区亮秀路112号Y1座203室",
      corporateName:"上海图漾信息科技有限公司"
    },
    {
      name:"南京",
      langname:"南京（办事处）",
      address:"南京浦口区江浦街道浦口大道毅达汇创中心3号楼1105室",
      corporateName:"上海图漾信息科技有限公司"
    },
    {
      name:"深圳",
      langname:"深圳（办事处）",
      address:"深圳市宝安区福永街道福永意库13栋303室",
      corporateName:"上海图漾信息科技有限公司"
    }
  ],
  advantages:{
    advantages:"/static/brand/zhitong/youshi/left.png",
    advantagesTitle:"/static/brand/zhitong/youshi/top.png",
    info:"产品在效率、空程、温升、噪音等指标上达到了国外主流产品水平。精度保持性、传动精度和刚性等3项指标略优，疲劳寿命指标大幅优于国外主流产品。",
    type:1
  },
  certify:[
     
  ],
  pindustry:{
      industryTitleImg:"/static/brand/qingneng/hangye/industryTitleImg.png",
      list:[
        {
          bjimg:"/static/brand/tuyang/hangye/1.png",
          title:"工业自动化",
        },
        {
          bjimg:"/static/brand/tuyang/hangye/2.png",
          title:"物流科技",
        },
        {
          bjimg:"/static/brand/tuyang/hangye/3.png",
          title:"测量检测",
        },
        {
          bjimg:"/static/brand/tuyang/hangye/4.png",
          title:"医疗设备",
        },
        {
          bjimg:"/static/brand/tuyang/hangye/5.png",
          title:"教育/科研",
        },
        {
          bjimg:"/static/brand/tuyang/hangye/6.png",
          title:"客流计",
        },
      ]    
    },
  bigimg:"/static/brand/zhitong/bigimg/big.png",

  otherProductsAdvantages:{
    productsTitle:"/static/brand/zhitong/tedian/title.png",
    aboutTitleWidth:"849px",
    height:"214px",
    textTitle:"自主知识产权的主动双目技术",
    textList:[
      '比传统双目视觉更多的景深细节',
      '更强的环境光抗干扰能力'
    ],
    textImg:"/static/brand/tuyang/youshi/product.png",
  },
  aboutus:
  {
        info:"图漾科技（Percipio.XYZ）是全球领先的3D机器视觉供应商，为工业和行业应用提供高性价比的3D工业相机和配套软件方案。公司总部位于上海、在南京、深圳和广州设有研发及销售服务中心。基于创新并拥有核心专利的双目结构光技术， 图漾不断推出富有竞争力的产品线，满足工业自动化、工业测量、物流科技、商业应用和其他多种场景，产品出货量已经全球领先。图漾秉持独立视觉产品供应商的商业模式，为各行业的设备和系统集成商客户提供优质产品和服务。 图漾的创新产品方案与合作伙伴的行业专家知识、系统集成能力及市场资源优势相整合，共同帮助最终用户降本增效、创造使用价值，实现3D机器视觉无处不在的愿景。",
        video:"https://atomrobot.oss-cn-hangzhou.aliyuncs.com/video/mvb/tuyang.mp4",
        poster:"/static/brand/tuyang/guanyu/video.png",
        aboutTitle:"/static/brand/tuyang/guanyu/top.png",
        aboutTitleWidth:"510px"
  },
  
  metaInfo:{
    title:"图漾科技_Movibot品牌_3D视觉系统",
    keywords:"3D视觉系统_3D相机_图漾科技",
    description:"图漾科技是全球领先的3D机器视觉供应商，MOVIBOT为您提供该品牌及产品介绍，丰富的产品选型，让您更快速准确的找到所需商品。",
  }
  


}
export default {
  brandInfoAll
};


// WEBPACK FOOTER //
// ./src/data/brand/4.js